/**
 * Product Form Components
 *
 */
optionName='';
variantFound = false;
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
   if (this.form) {
   this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
   }
    this.cartElement = document.querySelector('ajax-cart');
    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  async onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const giftItem = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');
    const pdpContainer = this.closest('.product-details-wrapper');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
    
    let price;
    if (evt.currentTarget.closest("[data-product-grid]")!= null  ) {
      let parentElement = evt.currentTarget.closest("[data-product-grid]");
      if(parentElement.querySelector('[data-currentprice]')) price = parentElement.querySelector('[data-currentprice]').innerHTML;
    }else if (evt.currentTarget.closest("[data-product-container]") != null) {
      let parentElement = evt.currentTarget.closest("[data-product-container]");
      if(parentElement.querySelector('[data-currentprice]')) price = parentElement.querySelector('[data-currentprice]').innerHTML;
    }

    if (window.globalVariables.template != 'product') {
        if (submitButton.querySelector(".add-text").hasAttribute('optiontype')) {
          let attributName = submitButton.querySelector(".add-text").getAttribute('optiontype');
      
          window.notificationEle.updateNotification('Cart Error', `Select a ${attributName} first`, {
            type: 'error', // success, warning, info, error
            timeout: 3000 // after how many seconds the notification should disappear
          });
          setTimeout(() => {
            submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
          }, 3000);
          return false
        }
    }

 
    // ----------------- for free gift with the one time products -----------------
    let isProductEligibleForPromo = evt.currentTarget.closest("product-form").querySelector('[data-promoScript]');

    if(isProductEligibleForPromo && isProductEligibleForPromo != null){ 
      let promoProduct = document.getElementById("promo-gift");
      let promoProductId = promoProduct.getAttribute("data-promo-gift-variant-id");

      let giftProperty = {};
      giftProperty['_promoGiftProduct']='true';
      giftProperty['_main_product_auto_renew_id'] = JSON.parse(serializeForm(this.form)).id;

      giftItem.push( {
        quantity: 1,
        id: parseInt(promoProductId),
        properties : giftProperty
      });

      await fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: giftItem
        })
      }).then((res)=>res.json())
    }

    // ---------------------------------------------------
   
    ttq.track('AddToCart',{  
      content_id: JSON.parse(serializeForm(this.form)).id,
      quantity: JSON.parse(serializeForm(this.form)).quantity,
      value: price,
      currency: 'USD',})
   

      const selectCrateElement = document.getElementById("Option-crate");
      const selectedCrateOption = selectCrateElement?.value;
      
      const selectElement = document.querySelector('select[name="options[Size]"]');
      const selectedOption = selectElement?.value;
      
      const proCratePriceScript = document.querySelector('script[data-ProCrate]');
      
      if (
        proCratePriceScript &&
        selectCrateElement &&
        selectElement &&
        selectedCrateOption?.toLowerCase() === 'platecrate pro'
      ) {
        try {
          const parsedPrices = JSON.parse(proCratePriceScript.textContent);
          const match = parsedPrices.find(p => p.pro_crate_option === selectedOption);
          const formData = JSON.parse(serializeForm(this.form));
      
          if (match) {
            formData.id = match.variant_id; // Replace form variant ID
          }
      
          addItems.push(formData);
        } catch (err) {
          console.error("Error parsing ProCrate data or serializing form:", err);
        }
      } else {
        try {
          const formData = JSON.parse(serializeForm(this.form));
          addItems.push(formData);
        } catch (err) {
          console.error("Error serializing form:", err);
        }
      }


    
    if(pdpContainer){
      let addOnItemsEle = pdpContainer.querySelectorAll('[data-addon-selection]:checked');
      addOnItemsEle.forEach((addOn)=>{
        if(!addOn.disabled){
          let addOnParent = addOn.closest('addons-form');
          let addOnJSON = {
            id: addOnParent.querySelector('.variant--id').value,
            quantity: addOnParent.querySelector('.product-quantity').value
          }
          addItems.push(addOnJSON);
        }
      });
    }

    const body = JSON.stringify({
      items: addItems
    });
    await fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then(() => {
        if(document.querySelector('#PopupModal-quickshop')){
          document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
        }
        //this.cartElement.getCartData('open_drawer');
        window.location.href = "/cart";
        if(qtyInput) qtyInput.value = 1;
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;
    let decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');

    if(action == 'decrease' && currentQty <= 1){
      if(decreaseQtyBtn) decreaseQtyBtn.classList.add('disabled');
      return false;
    }else if(action == 'decrease'){
      finalQty = currentQty - 1;
      finalQty == 1 ? decreaseQtyBtn.classList.add('disabled') : decreaseQtyBtn.classList.remove('disabled');
    }else{
      if(decreaseQtyBtn) decreaseQtyBtn.classList.remove('disabled');
      finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
  }
}
customElements.define('product-form', ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;


    if(this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.init()
  }

 

 init() {
 
  
  const radioButtons = document.querySelectorAll('input[name="crate_type"]');
  if (radioButtons.length > 0) {
    radioButtons.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.checked) {
          const value = radio.value.toLowerCase();
        
          

          let productWrap = radio.closest('[data-product-container]');
          if(!productWrap) return;

          const selectedText = productWrap.querySelector('[data-selected-crate-type]');
          selectedText.textContent = value.replace('platecrate ', 'Plate Crate '); // Optional formatting

          // Optional: toggle product elements
          const proElement = productWrap.querySelector('[data_crate="pro"]');
          const classicElement = productWrap.querySelector('[data_crate="classic"]');
          const proElementForm = productWrap.querySelector('[data-type="pro"]');
          const classicElementForm = productWrap.querySelector('[data-type="classic"]');
        let firstEnabledRadio ;
          
            

          if (value === 'platecrate pro') {
            proElement?.classList.remove('d-none');
            classicElement?.classList.add('d-none');
            proElementForm?.classList.remove('d-none');
            classicElementForm?.classList.add('d-none');
            firstEnabledRadio = proElementForm.querySelector('input[data-radio-btn]:not([disabled])');
          } else {
            proElement?.classList.add('d-none');
            classicElement?.classList.remove('d-none');
            proElementForm?.classList.add('d-none');
            classicElementForm?.classList.remove('d-none');
            firstEnabledRadio = classicElementForm.querySelector('input[data-radio-btn]:not([disabled])');
          }
          if (firstEnabledRadio) {
              firstEnabledRadio.checked = true;

              // Dispatch a real 'change' event
              const changeEvent = new Event('change', { bubbles: true });
              firstEnabledRadio.dispatchEvent(changeEvent);
            }

        
        }
      });
    });
  }
}



  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
  onVariantChange(_event) {
    if(window.globalVariables.templateSuffix !='catapult-landing'){
    this.setCurrentVariant();
    }
    this.variantData = this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    
     this.updateVariantStatuses();
    if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;


    if (window.globalVariables.template == 'collection') {
      if (!this.currentVariant) {
        let ele = _event.currentTarget;
        optionName =  ele.querySelector('.variant_selector').value;
        variantFound = false;
        ele.closest(".product-form").querySelector(".add-text").setAttribute("optionType" ,optionName);
      }else{
        let ele = _event.currentTarget;
        if(ele){
        optionName = '';
        variantFound = true;
        ele.closest("[data-product-container]").querySelector(".add-text").removeAttribute("optionType");
        }

      }
     
    }

     let options = this.form.querySelectorAll('[data-optionindex]');
     if(options.length > 0){
      options.forEach(option => {
        let lableID = 'option'+option.dataset.optionindex;
        const selectedValue = option.querySelector('input[type="radio"]:checked');
        const lable = option.querySelector('.selected-option');
        if(!lable || !lableID || !selectedValue) return;
        lable.innerHTML = selectedValue.value;
      });
    }

    if (!this.currentVariant) {
      this.toggleAddButton('disable');
      // Variant name update
      // let options = this.form.querySelectorAll('[data-optionindex]');
      // options.forEach(option => {
      //   let lableID = 'option'+option.dataset.optionindex;
      //   const selectedValue = option.querySelector('input[type="radio"]:checked');
      //   const lable = option.querySelector('.selected-option');
      //   if(!lable || !lableID || !selectedValue) return;
      //   lable.innerHTML = selectedValue.value;
      // });
    } else {
      if(this.formType == 'grid'){
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid); 
      }else{
        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
      }

     
     
      //  this.updateVariantStatuses();
     //  if(!document.querySelector(`[data-type="pro"]`)) {
      this.updateURLandID(this.currentVariant);
      // }
      this.toggleAddButton('enable');
    }
  }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid 
   */
  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = '?variant=' + this.currentVariant.id;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
  }

  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    // get all current values from selectors
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      // assign variant details to this.currentVariant if all options are present
      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
      }
    });
  }

  updateVariantStatuses() {
  const selectedValue = this.querySelector(':checked')?.value;
  if (!selectedValue) return;

  const selectedOptionOneVariants = this.variantData.filter(
    (variant) => selectedValue === variant.option1
  );

  const inputWrappers = [...this.querySelectorAll('.product-form__input')];

  // ✅ Handle single option case
  if (inputWrappers.length === 1) {
    const inputs = [...inputWrappers[0].querySelectorAll('input[type="radio"], option')];
    const availableValues = this.variantData
      .filter((variant) => variant.available)
      .map((variant) => variant.option1);
    this.setInputAvailability(inputs, availableValues);
    return;
  }

  // ✅ Handle multiple option case
  inputWrappers.forEach((option, index) => {
    if (index === 0) return;

    const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
    const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked')?.value;

    const availableOptionInputsValue = selectedOptionOneVariants
      .filter(
        (variant) =>
          variant.available && variant[`option${index}`] === previousOptionSelected
      )
      .map((variantOption) => variantOption[`option${index + 1}`]);

    this.setInputAvailability(optionInputs, availableOptionInputsValue);
  });
}




  setInputAvailability(elementList, availableValuesList) {

    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
     
        element.toggleAttribute('disabled', !availableElement)
  
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    // update query string with latest variant ID
    if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    // update variant input with currentVariant Id
    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  /**
   * Render Product data based on current variant
   * @param {event} currentVariant 
   * @param {element} container 
   */
  renderProductInfo(currentVariant, container) {
    if(!currentVariant || !container) return;

    this.updateProductPrice(currentVariant,container);

     // Variant name update
    let options = this.form.querySelectorAll('[data-optionindex]');
   
    options.forEach(option => {
      let lableID = 'option'+option.dataset.optionindex;
     
      const lable = option.querySelector('.selected-option');
     
      if(!lable || !lableID) return;
      lable.innerHTML = currentVariant[lableID];
    });
    if(document.querySelector('[data-crate-dropdown]') || document.querySelector('[data-subscribe-btn-block]')){
      document.cookie = `size_cookie=${currentVariant.title};expires=30;path=/`;
    }

    // Grid Image Update on variant selection
    if(this.formType == 'grid'){
      if(!currentVariant.featured_image) return;
      const featuredImage = container.querySelector('[data-feauredImage]');
      let updatedSrc = currentVariant.featured_image.src;
      if(updatedSrc){
        featuredImage.src = updatedSrc;
        featuredImage.srcset = updatedSrc;
      }
    }else{
     
      if(!currentVariant.featured_image) return;
      let imageID = currentVariant.featured_media.id;
      let imageSlide = document.querySelector(`.product--media[data-mediaID="${imageID}"]`);
      if(this.formType == 'quickshop'){
        imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${imageID}"]`);
      }
      if(!imageSlide) return;
      let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
      if(quickShopSlider) quickShopSlider.slideTo(slideIndex, 2000, true);
      else if(productSlider)  productSlider.slideTo(slideIndex, 2000, true);
    }

   
  }

  updateProductPrice(currentVariant, container){
    // const selectElement = document.querySelector('select[name="options[Size]"]');
    // const selectedOption = selectElement.value;
    let selectedOption = window.globalVariables.product.currentVariant.title;
    if(!currentVariant || !container) return;
    let priceElement = container.querySelector('[data-currentPrice]');
     let priceCompareElement = container.querySelector('[data-compareprice]');
    let priceElementATC = document.querySelector('[data-atc-price]');
    const proCratePriceScript = document.querySelector('script[data-ProCrate]');
    
    // For product pages only (not grids), also get price elements outside container
    // This handles mobile price that's placed before the main container in tee-popper-pdp template
    const isProductPage = this.formType === 'product-page';
    const productSection = isProductPage ? container.closest('section[data-product-container]')?.parentElement : null;
    
    // Get price elements - scoped to section for product pages, container for grids
    const getPriceElements = (selector) => {
      if (isProductPage && productSection) {
        return productSection.querySelectorAll(selector);
      }
      return container.querySelectorAll(selector);
    };
    
    const allPriceElements = getPriceElements('[data-currentPrice]');
    const allComparePriceElements = getPriceElements('[data-comparePrice]');
    
    if (proCratePriceScript){
      const parsedPrices = JSON.parse(proCratePriceScript.textContent);
      const match = parsedPrices.find(p => p.pro_crate_option == selectedOption);
      const selectedCrateType = document.querySelector('[data-crate-type]')?.value?.toLowerCase();
      if (selectedCrateType === 'platecrate pro' && match && match.pro_crate_price) {
        let formattedPrice = Shopify.formatMoney(match.pro_crate_price, window.globalVariables.money_format);
        if (priceElement) priceElement.innerHTML = formattedPrice;
        // Update all price elements in scope
        allPriceElements.forEach(el => el.innerHTML = formattedPrice);
      } else {
        let price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
        if (priceElement) priceElement.innerHTML = price;
         if(priceElementATC) priceElementATC.innerHTML = price;
        // Update all price elements in scope
        allPriceElements.forEach(el => el.innerHTML = price);
        
        let formattedComparePrice = Shopify.formatMoney( currentVariant.compare_at_price, window.globalVariables.money_format);
        if( currentVariant.compare_at_price <= currentVariant.price && document.querySelector("[data-product-container] [data-compareprice]")) {
            document.querySelector("[data-product-container] [data-compareprice]").classList.add("d-none")
          }else if (document.querySelector("[data-product-container] [data-compareprice]")){
            document.querySelector("[data-product-container] [data-compareprice]").classList.remove("d-none");
            document.querySelector("[data-product-container] [data-compareprice]").innerText = formattedComparePrice;
          }

      }

    }
    else{
      let price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
      if(priceElement) priceElement.innerHTML = price;
      if(priceElementATC) priceElementATC.innerHTML = price;
      // Update all price elements in scope
      allPriceElements.forEach(el => el.innerHTML = price);
    }

    // Compare At Price Update
    let compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    let comparePriceElement = container.querySelector('[data-comparePrice]');

    if(comparePriceElement) {
      comparePriceElement.innerHTML = compare_price;
      if(currentVariant.compare_at_price <= 0 || currentVariant.compare_at_price <= currentVariant.price){
        comparePriceElement.style.display = 'none';
        comparePriceElement.classList.add('d-none');
      }else{
        comparePriceElement.style.display = 'block';
        comparePriceElement.classList.remove('d-none');
      }
    }
    
    // Update all compare price elements in scope (including mobile for product pages)
    allComparePriceElements.forEach(el => {
      el.innerHTML = compare_price;
      if(currentVariant.compare_at_price <= 0 || currentVariant.compare_at_price <= currentVariant.price){
        el.style.display = 'none';
        el.classList.add('d-none');
      }else{
        el.style.display = '';
        el.classList.remove('d-none');
      }
    });
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == 'disable') {
      //  this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        // this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
        this.addBtn.removeAttribute('disabled');
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;

    } else if(this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
    } else {
      this.addBtn.removeAttribute('disabled');
      if(this.form.classList.contains('cart-upsell-form')){
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.upsellAddText;
      }else{
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
      }
    }
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}
  
  customElements.define('variant-selects', VariantSelects);
  
  /**
   * Radio Button swatch
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();

      this.form = this.closest('form') || this.querySelector('.form-element');
      this.formType = this.form.dataset.format;
      
      const colorSwatchContainer = this.querySelector('.color-swatch');
      if(colorSwatchContainer){
        const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
        colorSwatches.forEach(swatch => {
          let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
          let swatchStyle = Utility.getSwatchStyle(colorHandle);
          swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
        });
      }
    }
  }
  customElements.define('variant-radios', VariantRadios);